import React, { useState } from 'react';
import Shell from '../../common/components/Shell/Shell';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AttendanceexceptionPresenter from './AttendanceexceptionPresenter';
import { attendanceException } from '../../api/services/attendanceException';
import toast from 'react-hot-toast';

export default function AttendanceexceptionController() {
  const { i18n, t } = useTranslation();
  return (
    <>
      <Shell>
        <Grid
          container
          style={{
            maxWidth: 'auto',
            marginLeft: '7.25em',
          }}
        >
          <AttendanceexceptionPresenter
            trans={t}
            i18n={i18n}
          />
        </Grid>
      </Shell>
    </>
  );
}
